import { hasValidChars } from '../utils';

export const validateSavFields = (
  formData,
  setFormError,
  isErrorRequired = true
) => {
  console.log(formData);
  let isValid = true;
  const newErrors = {};

  if (!formData?.lastName || formData.lastName?.length < 3) {
    newErrors.lastName = 'Le nom doit contenir au moins 3 caractères';
    isValid = false;
  }

  if (!formData?.firstName || formData.firstName?.length < 3) {
    newErrors.firstName = 'Le prénom doit contenir au moins 3 caractères';
    isValid = false;
  }

  if (!formData?.phone || formData.phone?.length < 10) {
    newErrors.phone =
      'Le numéro de téléphone doit contenir au moins 10 caractères';
    isValid = false;
  }

  if (!formData?.reason.length > 0) {
    newErrors.reason = 'Un motif doit être sélectionné';
    isValid = false;
  }

  if (!formData?.orderPicker.length > 0) {
    newErrors.orderPicker = 'Un préparateur doit être sélectionné';
    isValid = false;
  }

  // verification valide shipping address
  if (!formData?.shippingAddress) {
    newErrors.shippingAddress = "L'adresse est requise";
    isValid = false;
  } else if (formData.shippingAddress?.address1?.length < 3) {
    newErrors.shippingAddress.address1 =
      "L'adresse doit contenir au moins 3 caractères";
    isValid = false;
  }

  if (!formData?.shippingAddress?.postalCode) {
    newErrors.shippingAddress.postalCode = 'Le code postal est requis';
    isValid = false;
  } else if (formData?.shippingAddress.postalCode?.length < 3) {
    newErrors.shippingAddress.postalCode =
      'Le code postal doit contenir au moins 3 caractères';
    isValid = false;
  }

  if (!formData?.shippingAddress?.city) {
    newErrors.shippingAddress.city = 'La ville est requise';
    isValid = false;
  } else if (formData?.shippingAddress.city?.length < 3) {
    newErrors.shippingAddress.city =
      'La ville doit contenir au moins 3 caractères';
    isValid = false;
  }

  // verification valide billing address
  if (!formData?.billingAddress) {
    newErrors.billingAddress = "L'adresse est requise";
    isValid = false;
  } else if (formData.billingAddress?.address1?.length < 3) {
    newErrors.billingAddress.address1 =
      "L'adresse doit contenir au moins 3 caractères";
    isValid = false;
  }

  if (!formData?.billingAddress?.postalCode) {
    newErrors.billingAddress.postalCode = 'Le code postal est requis';
    isValid = false;
  } else if (formData?.billingAddress.postalCode?.length < 3) {
    newErrors.billingAddress.postalCode =
      'Le code postal doit contenir au moins 3 caractères';
    isValid = false;
  }

  if (!formData?.billingAddress?.city) {
    newErrors.billingAddress.city = 'La ville est requise';
    isValid = false;
  } else if (formData?.billingAddress.city?.length < 3) {
    newErrors.billingAddress.city =
      'La ville doit contenir au moins 3 caractères';
    isValid = false;
  }

  if (formData.lines?.length === 0) {
    newErrors.lines = "Aucun produit n'a été ajouté";
    isValid = false;
  } else {
    formData.lines.map((item) => {
      if (item?.internalProduct?.length != 10) {
        newErrors.lines =
          'Les références des produit doivent être au format: ABC-000000';
        isValid = false;
      }
    });
  }

  if (formData.amountTtcNet === 0 && formData.isPayable) {
    newErrors.amountTtcNet =
      'Le montant TTC doit être supérieur à 0 si la commande est payante';
    isValid = false;
  }

  // Validate special characters in address fields
  const shippingAddressFields = {
    firstName: formData.firstName,
    lastName: formData.lastName,
    address1: formData.shippingAddress.address1,
    address2: formData.shippingAddress.address2,
    postalCode: formData.shippingAddress.postalCode,
    city: formData.shippingAddress.city,
  };

  const billingAddressFields = {
    firstName: formData.firstName,
    lastName: formData.lastName,
    address1: formData.billingAddress.address1,
    address2: formData.billingAddress.address2,
    postalCode: formData.billingAddress.postalCode,
    city: formData.billingAddress.city,
  };

  for (const [key, value] of Object.entries(shippingAddressFields)) {
    if (value && !hasValidChars(value)) {
      newErrors[key] = 'Le champ contient des caractères non valides';
      isValid = false;
    }
  }

  for (const [key, value] of Object.entries(billingAddressFields)) {
    if (value && !hasValidChars(value)) {
      newErrors[key] = 'Le champ contient des caractères non valides';
      isValid = false;
    }
  }
  if (isErrorRequired) {
    setFormError(newErrors);
  }
  return isValid;
};
